import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import SmallLoader from "./Components/CommonComponents/SmallLoader";
import { useEffect } from "react";
import { getLogin, getTokenReady } from "./features/Loginuser";

function ProtectedRoute({ children }) {
  const login = useSelector(getLogin);

  const tokenReady = useSelector(getTokenReady);

  if (!login) {
    return <Navigate to="/login" replace />;
  }

  if (!tokenReady) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          height: "100vh",
          backgroundColor: "#f5f5f5",
        }}
      >
        <SmallLoader loadingtext="Fetching Token..." />
      </div>
    );
  }

  return children;
}

export default ProtectedRoute;
